import React, {useEffect, useState} from 'react';
import cards from '../images/cards.svg';

const Payment = (props) => {
  return (
    <div className='payment'>
      {props.iframeUrl && (
        <>
          <iframe
            frameBorder='0'
            scrolling='no'
            className='nvc-iframe'
            src={props.iframeUrl}
            title=''
            style={props.type == '2' ? {height: '500px'} : {}}
          />
          <div className='info-wrapper'>
            <p>
              {' '}
              לא כולל כרטיסי דיירקט
              <span className='cards-img' style={{backgroundImage:cards.bg()}}/>
            </p>
            <p dir='rtl'>רכישה מאובטחת ב - SSL</p>
          </div>
        </>
      )}
    </div>
  );
};
export default Payment;
